import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/charge/list',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  }
};
